import {createApiClient} from "./apiClient";
import {config} from "../config";

const apiClient = createApiClient({
    baseURL: config.bffUrl + '/api/users/',
});

export const fetchCurrentUser = async () => {
    try {
        const response = await apiClient.get('current');
        return response.data;
    } catch (err) {
        console.error('Error fetching current user', err);
        throw err;
    }
}

export const saveCurrentUser = async (user) => {
    try {
        const response = await apiClient.post('current', user);
        return response.data;
    } catch (err) {
        console.error('Error saving current user', err);
        throw err;
    }
}

export const fetchCurrentOrganization = async () => {
    try {
        const response = await apiClient.get('current/organization');
        return response.data;
    } catch (err) {
        console.error('Error fetching current organization', err);
        throw err;
    }
}
